import React from "react";

import { Icon } from "components";

import { EvidenceSignal } from "pages/admin/verifications/components/automations/types";

export const EvidenceSignals = ({ signals }: { signals: EvidenceSignal[] }) => (
  <span className="evidence-signals">
    {signals.map(({ key, iconName, tone, label }) => (
      <span key={key} className={`evidence-signal ${tone}`}>
        <Icon iconName={iconName} size="s" />
        {label && <span>{label}</span>}
      </span>
    ))}
  </span>
);
